"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;const create=()=>({track:()=>{}});var _default=exports.default={create};
//# sourceMappingURL=DummyTrackerFactory.js.map